import {Chip} from 'platform/components';
import {HStack, Show, Stack, Text, VStack} from 'platform/foundation';

import {isNil} from 'ramda';

import {RelativeFilterChoice} from '@dms/api/core';
import i18n from '@dms/i18n';

interface ThreeWayPropertyChipsProps {
  label: string;
  value: RelativeFilterChoice | null;
  onChange: (next: RelativeFilterChoice | null) => void;
  sameAndBetterHint?: string;
  isReadOnly?: boolean;
}

export function ThreeWayPropertyChips(props: ThreeWayPropertyChipsProps) {
  return (
    <VStack spacing={1}>
      <Stack
        direction={['column', 'row']}
        align={[undefined, 'center']}
        justify="space-between"
        spacing={2}
      >
        <Text size="small">{props.label}</Text>
        <HStack spacing={1}>
          <Chip
            label={i18n.t('entity.sourcing.relativeFilters.mode.same')}
            value={props.value === 'same'}
            onChange={() => props.onChange('same')}
            size="small"
            isDisabled={props.isReadOnly}
          />
          <Chip
            label={i18n.t('entity.sourcing.relativeFilters.mode.sameAndBetter')}
            value={props.value === 'same_better'}
            onChange={() => props.onChange('same_better')}
            size="small"
            isDisabled={props.isReadOnly}
          />
          <Chip
            label={i18n.t('entity.sourcing.relativeFilters.mode.any')}
            value={isNil(props.value)}
            onChange={() => props.onChange(null)}
            size="small"
            isDisabled={props.isReadOnly}
          />
        </HStack>
      </Stack>
      <Show when={!!props.sameAndBetterHint && props.value === 'same_better'}>
        <Text size="xSmall" color="secondary">
          {props.sameAndBetterHint}
        </Text>
      </Show>
    </VStack>
  );
}
